import * as d3 from "d3";

const draw = (props) => {
  // const now = Date.now();

  // Clear up page
  d3.select(".timeline-vis > *").remove();

  // Constants
  const margin = { top: 10, right: 40, bottom: 40, left: 10 };
  const timelineVPos = 300;
  const w = Math.max(
    document.documentElement.clientWidth, // Get window width
    window.innerWidth || 0
  );
  const h = Math.max(
    document.documentElement.clientHeight / 2, // Get window height
    window.innerHeight / 2 || 0
  );

  // Turn on and off
  var isAdding = false;
  var t = d3.transition().duration(250).ease(d3.easeLinear);

  // Initiate svg canvas
  const svgCanvas = d3
    .select(".timeline-vis")
    .append("svg")
    .style("position", "absolute")
    .attr("width", w)
    .attr("height", h + margin.top + margin.bottom)
    .append("g")
    .attr("transform", "translate(" + 0 + "," + margin.top + ")")
    .on("click", canvasClicked);

  // Set the zoom and Pan features
  var zoom = d3
    .zoom()
    .scaleExtent([0.1, 1000])
    .extent([
      [0, 0],
      [w, h],
    ])
    .on("zoom", updateChart);

  // Add X axis
  var x = d3
    .scaleTime()
    .domain([new Date(1970, 1, 1), new Date(2030, 1, 1)])
    .range([0, w])
    .nice(); // make start and end year display nicely

  // Draw out all items in timelineEvents
  if (props.timelineEvents.length > 0) {
    console.log(props.timelineEvents);

    var eventMapping = svgCanvas
      .selectAll("text")
      .data(props.timelineEvents)
      .enter();

    eventMapping
      .append("circle")
      .attr("cx", function (d) {
        return x(Date.parse(d.time));
      })
      .attr("cy", timelineVPos + 72)
      .attr("r", 5)
      .attr("fill", "white");

    eventMapping
      .append("text")
      .attr("class", "eventBox")
      .attr("fill", "grey")
      .attr("font-size", "12px")
      .attr("x", function (d) {
        return x(Date.parse(d.time));
      })
      .attr("y", timelineVPos - 12)
      .text((datapoint) => datapoint.time);

    eventMapping
      .append("text")
      .attr("class", "eventBox")
      .attr("fill", "white")
      .attr("font-size", "18px")
      .attr("font-weight", "700")
      .attr("x", function (d) {
        return x(Date.parse(d.time));
      })
      .attr("y", timelineVPos + 10)
      .text((datapoint) => datapoint.title);

    eventMapping
      .append("text")
      .attr("class", "eventBox")
      .attr("fill", "white")
      .attr("font-size", "18px")
      .attr("font-weight", "300")
      .attr("x", function (d) {
        return x(Date.parse(d.time));
      })
      .attr("y", timelineVPos + 30)
      .text((datapoint) => datapoint.description);
  }

  // Display X axis / timeline
  svgCanvas
    .append("g")
    .attr("class", "x axis")
    .attr("transform", "translate(0," + (timelineVPos + 70) + ")")
    .call(d3.axisBottom(x))
    .selectAll("text")
    .attr("y", 16)
    .style("text-anchor", "start");

  // This add an invisible rect on top of the chart area. This rect can recover pointer events: necessary to understand when the user zoom
  svgCanvas
    .append("rect")
    .attr("width", w)
    .attr("height", h)
    .style("fill", "none")
    .style("pointer-events", "all")
    .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
    .call(zoom);

  // When the canvas is clicked - pop out add event box
  function canvasClicked() {
    if (d3.event.defaultPrevented) return; // remove drag

    var coorValue = d3.mouse(this);
    var x = coorValue[0];
    var y = coorValue[1];

    // Turn event form on and off
    // TODO: rename form-wrapper to something more descriptive
    if (isAdding) {
      d3.select(".form-wrapper")
        .style("display", "block")
        .style("top", y + 100 + "px")
        .style("left", x + 20 + "px")
        .transition(t)
        .style("opacity", "1");
      isAdding = false;
    } else {
      d3.select(".form-wrapper")
        .transition(t)
        .style("opacity", "0")
        .style("display", "none");
      isAdding = true;
    }
  }

  // A function that updates the chart when the user zoom and thus new boundaries are available
  function updateChart() {
    // recover the new scale
    var newXAxis = d3.event.transform.rescaleX(x);

    // update axes with these new boundaries
    svgCanvas
      .select(".axis")
      .call(d3.axisBottom(x).scale(newXAxis))
      .selectAll("text")
      .attr("y", 16)
      .style("text-anchor", "start");

    // update circle position
    svgCanvas.selectAll("circle").attr("cx", function (d) {
      return newXAxis(Date.parse(d.time));
    });

    svgCanvas.selectAll("text").attr("x", function (d) {
      return newXAxis(Date.parse(d.time));
    });
  }
};

export default draw;
